import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import {
    duplicatesDebugLogger,
    duplicatesPromoBanner,
    IS_DUPLICATES_ENABLED,
} from 'reactApp/appHelpers/featuresHelpers/features/duplicates';
import { getUserHasDuplicates } from 'reactApp/modules/duplicates/duplicates.selectors';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { getDuplicatesPromoBannerHidden } from 'reactApp/ui/Duplicates/DuplicatesPromoBanner/DuplicatesPromoBanner.helpers';
import { ConditionsCheckType, getCheckAllConditions } from 'reactApp/utils/conditionChecker';

const duplicatesCheckAllConditionsTrue = getCheckAllConditions(duplicatesDebugLogger, ConditionsCheckType.FirstFalse);

export const useDuplicatesEntryPointBanner = () => {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isCorpUser = useSelector(UserSelectors.isCorpUser);
    const isMobile = useSelector(EnvironmentSelectors.isMobile);
    const isOverquota = useSelector(UserQuotaSelectors.isOverquotaBySpaceAndApi);
    const isQuotaLoaded = useSelector(UserQuotaSelectors.isQuotaLoaded);
    const storage = useSelector(getCurrentStorage);
    const hasDuplicates = useSelector(getUserHasDuplicates);
    const { isHome, isAlbums, isDuplicates } = getStorage(storage);

    const dispatch = useDispatch();

    const [isHidden, setIsHidden] = useState<boolean>(true);

    useEffect(() => {
        setIsHidden(Boolean(dispatch(getDuplicatesPromoBannerHidden())));
    }, [dispatch]);

    const shouldShowBanner = duplicatesCheckAllConditionsTrue('duplicatesCheckAllConditionsTrue', {
        isDuplicatesEnabled: IS_DUPLICATES_ENABLED,
        isDuplicatesBannerEnabled: duplicatesPromoBanner,
        isNotHidden: !isHidden,
        isPageAllowed: isHome || isAlbums || isDuplicates,
        isNotBiz: !isBizUser,
        isNotOnPrem: !IS_ONPREMISE,
        isNotCorp: !isCorpUser,
        isNotPaid: !isPaidUser,
        isNotOverquota: !isOverquota,
        isOverquotaLoaded: isQuotaLoaded,
        isNotMobile: !isMobile,
        hasDuplicates,
    });

    return {
        shouldShowBanner,
        setIsHidden,
    };
};
